import { useQuery } from "@redux-requests/react";
import _ from "lodash";
import { types } from "../ducks";

const useUserMe = () => {
  const {
    data: { data: user },
    loading: userLoading
  } = useQuery({ type: types.GET_USER_ME, defaultData: { data: {} } });
  return {
    user: {
      ...user,
      hasRoles: roles => !_.isEmpty(_.intersection(user.roles || [], roles)),
      loaded: !_.isEmpty(user)
    },
    userLoading
  };
};

export default useUserMe;
